// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 24 24%27 stroke=%27%2349c1f4%27%3E%3Cpath stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M19 9l-7 7-7-7%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
:root {
  --light-blue: #49c1f4;
  --purple: #7761c1;
  --dark-purple: #322a52;
  --light-grey: #f9fdff;
  --white: #ffffff;
  --black: #000000;
  --dark-bg: #121212;
  --dark-card: #1e1e1e;
  --transition: all 0.3s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

body {
  background-color: var(--dark-bg);
  color: var(--light-grey);
  line-height: 1.6;
  overflow-x: hidden;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Typography */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--white);
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.5rem;
}

p {
  margin-bottom: 1rem;
}

a {
  color: var(--light-blue);
  text-decoration: none;
  transition: var(--transition);
}

a:hover {
  color: var(--purple);
}

/* Header & Navigation */
header {
  background-color: rgba(18, 18, 18, 0.9);
  backdrop-filter: blur(10px);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  padding: 1rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 40px;
  width: auto;
  margin-right: 10px;
}

.logo h1 {
  margin: 0;
  margin-left: 10px;
  font-size: 1.8rem;
  background: linear-gradient(90deg, var(--light-blue), var(--purple));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

nav ul {
  display: flex;
  list-style: none;
}

nav ul li {
  margin-left: 2rem;
}

nav ul li a {
  color: var(--light-grey);
  font-weight: 500;
  position: relative;
}

nav ul li a:hover {
  color: var(--light-blue);
}

nav ul li a::after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -5px;
  left: 0;
  background: linear-gradient(90deg, var(--light-blue), var(--purple));
  transition: var(--transition);
}

nav ul li a:hover::after {
  width: 100%;
}

.cta-buttons {
  display: flex;
  align-items: center;
}

.btn {
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  border: none;
  outline: none;
}

.btn-primary {
  background: linear-gradient(90deg, var(--light-blue), var(--purple));
  color: var(--white);
  margin-left: 1rem;
}

.btn-secondary {
  background: transparent;
  color: var(--light-grey);
  border: 1px solid var(--light-blue);
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

/* Hero Section */
.hero {
  height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 80px;
}

.map-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.2;
  z-index: -1;
}

.hero-content {
  max-width: 600px;
  z-index: 1;
}

.hero-content h1 {
  font-size: 3rem;
  margin-bottom: 1.5rem;
}

.hero-content p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}

.hero-cta {
  display: flex;
  gap: 1rem;
}

/* Features Section */
.features {
  padding: 5rem 0;
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title h2 {
  position: relative;
  display: inline-block;
  padding-bottom: 1rem;
}

.section-title h2::after {
  content: "";
  position: absolute;
  width: 50%;
  height: 3px;
  bottom: 0;
  left: 25%;
  background: linear-gradient(90deg, var(--light-blue), var(--purple));
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.feature-card {
  background-color: var(--dark-card);
  border-radius: 10px;
  padding: 2rem;
  transition: var(--transition);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.feature-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 1.5rem;
  color: var(--light-blue);
}

.feature-card h3 {
  margin-bottom: 1rem;
}

.feature-card p {
  color: var(--light-grey);
}

.expand-info {
  margin-top: 1rem;
  color: var(--light-blue);
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.expand-info svg {
  margin-left: 0.5rem;
  transition: var(--transition);
}

.expand-info:hover svg {
  transform: translateX(5px);
}

/* Services Section */
.services {
  padding: 5rem 0;
  background-color: rgba(18, 18, 18, 0.7);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.service-card {
  background-color: var(--dark-card);
  border-radius: 10px;
  padding: 2rem;
  transition: var(--transition);
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.service-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 1.5rem;
  color: var(--light-blue);
}

.service-card h3 {
  margin-bottom: 1rem;
}

.service-card p {
  color: var(--light-grey);
  flex-grow: 1;
}

/* Testimonials Section */
.testimonials {
  padding: 5rem 0;
}

.testimonial-slider {
  max-width: 800px;
  margin: 0 auto;
}

.testimonial-card {
  background: rgba(30, 30, 30, 0.7);
  backdrop-filter: blur(6px);
  border-radius: 10px;
  padding: 2rem;
  margin: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: none;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.4s, border 0.4s, transform 0.4s;
  animation: testimonialFloat 4s ease-in-out infinite alternate;
}

@keyframes testimonialFloat {
  0% {
    transform: translateY(0) scale(1);
    box-shadow: none;
  }
  100% {
    transform: translateY(-8px) scale(1.012);
    box-shadow: none;
  }
}

.testimonial-card::before,
.testimonial-card::after {
  display: none !important;
}

.testimonial-card .quote-icon {
  position: absolute;
  top: 18px;
  left: 24px;
  font-size: 2.5rem;
  color: var(--white);
  opacity: 0.18;
  z-index: 2;
  pointer-events: none;
  transition: color 0.3s;
}

.testimonial-card:hover .quote-icon {
  color: var(--white);
  opacity: 0.28;
}

.testimonial-content {
  font-style: italic;
  font-size: 1.35rem;
  color: var(--white);
  margin-bottom: 2rem;
  position: relative;
  z-index: 3;
  animation: testimonialFadeIn 1s cubic-bezier(0.4, 0, 0.2, 1);
}

.testimonial-author h4 {
  color: var(--white);
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
}

.testimonial-author p {
  color: var(--light-grey);
  font-size: 1rem;
  opacity: 0.8;
}

@keyframes testimonialFadeIn {
  0% {
    opacity: 0;
    transform: translateY(40px) scale(0.98);
  }
  60% {
    opacity: 0.7;
    transform: translateY(-8px) scale(1.03);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.testimonial-card {
  animation: testimonialFadeIn 1s cubic-bezier(0.4, 0, 0.2, 1);
}

.testimonial-card:hover {
  box-shadow: 0 12px 36px 0 rgba(73, 193, 244, 0.18),
    0 2px 12px 0 rgba(119, 97, 193, 0.12);
  border: 1.5px solid var(--light-blue);
  transform: translateY(-6px) scale(1.01);
}

/* Partners Section - Horizontal Card Layout */
.partners-grid {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 3rem;
  flex-wrap: wrap;
}

.partner-card-horizontal {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  box-shadow: none;
  border: none;
  min-width: 220px;
  max-width: 260px;
  margin: 0 1rem;
}

.partner-logo img {
  width: 240px !important;
  height: 160px !important;
  object-fit: contain;
  margin-bottom: 1rem;
  filter: grayscale(0%) brightness(2) contrast(1.2);
  opacity: 1;
  transition: filter 0.3s, opacity 0.3s;
}

.partner-logo img[alt="UCLA"] {
  filter: none !important;
  opacity: 1 !important;
}

.partner-logo img:hover {
  filter: grayscale(0%) brightness(2.2) contrast(1.3);
  opacity: 1;
}

.partner-info {
  text-align: center;
}

.partner-info h3 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: var(--white);
}

.partner-info p {
  font-size: 1rem;
  color: var(--text-on-dark);
}

@media (max-width: 900px) {
  .partners-grid {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
  .partner-card-horizontal {
    max-width: 90vw;
    min-width: 0;
  }
}

/* Footer */
footer {
  background-color: var(--dark-bg);
  padding: 3rem 0 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-column h3 {
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.footer-column ul {
  list-style: none;
}

.footer-column ul li {
  margin-bottom: 0.8rem;
}

.footer-column ul li a {
  color: var(--light-grey);
}

.footer-column ul li a:hover {
  color: var(--light-blue);
}

.copyright {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  color: var(--light-grey);
  font-size: 0.9rem;
}

/* Publications List */
.publications {
  padding: 5rem 0;
}

.publications-container {
  max-height: 500px;
  overflow-y: auto;
  background-color: var(--dark-card);
  border-radius: 10px;
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.publications-table {
  width: 100%;
  border-collapse: collapse;
}

.publications-table th,
.publications-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.publications-table th {
  background-color: rgba(73, 193, 244, 0.1);
  color: var(--light-blue);
  position: sticky;
  top: 0;
}

.publications-table tr:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

/* Team Section */
.team {
  padding: 5rem 0;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.team-card {
  background-color: var(--dark-card);
  border-radius: 10px;
  padding: 2rem;
  text-align: center;
  transition: var(--transition);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.team-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.team-avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  background-color: rgba(73, 193, 244, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: var(--light-blue);
}

.team-card h4 {
  font-size: 1.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; /* Optional: adds ... if name is too long */
}

.team-card p {
  color: var(--light-grey);
  margin-bottom: 1rem;
}

.team-social {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.team-social a {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--light-grey);
  transition: var(--transition);
}

.team-social a:hover {
  background-color: var(--light-blue);
  color: var(--white);
}

/* Contact Section */
.contact {
  padding: 5rem 0;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.contact-info {
  background-color: var(--dark-card);
  border-radius: 10px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.contact-info h3 {
  margin-bottom: 1.5rem;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.contact-icon {
  width: 20px;
  height: 20px;
  margin-right: 1rem;
  color: var(--light-blue);
}

.contact-text h4 {
  margin-bottom: 0.3rem;
}

.contact-text p,
.contact-text a {
  color: var(--light-grey);
}

.contact-form {
  background-color: var(--dark-card);
  border-radius: 10px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--light-grey);
}

.form-control {
  width: 100%;
  padding: 0.8rem;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--white);
}

.form-control:focus {
  outline: none;
  border-color: var(--light-blue);
}

textarea.form-control {
  min-height: 150px;
  resize: vertical;
}

/* Responsive Design */
@media (max-width: 992px) {
  .header-container {
    flex-direction: column;
  }

  nav ul {
    margin-top: 1rem;
  }

  nav ul li {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .cta-buttons {
    margin-top: 1rem;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }
}

@media (max-width: 768px) {
  nav ul {
    flex-direction: column;
    align-items: center;
  }

  nav ul li {
    margin: 0.5rem 0;
  }

  .hero {
    height: auto;
    padding: 120px 0 60px;
  }

  .hero-content {
    text-align: center;
  }

  .hero-cta {
    justify-content: center;
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.8s ease forwards;
}

/* Particle Background */
#tsparticles {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--dark-bg);
}

::-webkit-scrollbar-thumb {
  background: var(--dark-purple);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--purple);
}

/* Center the partners-cta section */
.partners-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  text-align: center;
}

.partners-cta p {
  margin-bottom: 1rem;
  font-size: 1.2rem;
  color: var(--white);
}

/* Video Background */
.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;
}

.video-background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.3;
}

/* Social Proof Badges */
.social-proof {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
  justify-content: center;
}

.badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem 1rem;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.badge img {
  height: 24px;
  width: auto;
}

.badge span {
  color: var(--white);
  font-size: 0.9rem;
}

/* Stats Section */
.stats {
  padding: 4rem 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  text-align: center;
}

.stat-card {
  padding: 2rem;
  background-color: var(--dark-card);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: var(--transition);
}

.stat-card:hover {
  transform: translateY(-5px);
  background-color: rgba(30, 30, 30, 0.8);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.stat-icon {
  width: 50px;
  height: 50px;
  margin: 0 auto 1rem;
  color: var(--light-blue);
  background: rgba(73, 193, 244, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-card h3 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(90deg, var(--light-blue), var(--purple));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.stat-card p {
  color: var(--light-grey);
  font-size: 1.1rem;
}

/* Blog Section */
.blog {
  padding: 5rem 0;
  background-color: var(--dark-bg);
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.blog-card {
  background-color: var(--dark-card);
  border-radius: 10px;
  overflow: hidden;
  transition: var(--transition);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.blog-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.blog-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.blog-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: var(--transition);
}

.blog-card:hover .blog-image img {
  transform: scale(1.1);
}

.blog-content {
  padding: 1.5rem;
}

.blog-category {
  display: inline-block;
  padding: 0.3rem 0.8rem;
  background: rgba(73, 193, 244, 0.1);
  color: var(--light-blue);
  border-radius: 50px;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.blog-content h3 {
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.blog-content p {
  color: var(--light-grey);
  margin-bottom: 1.5rem;
}

.read-more {
  color: var(--light-blue);
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.read-more:hover {
  color: var(--purple);
}

/* Enhanced Testimonials */
.testimonial-slider {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
}

.testimonial-slider .react-slideshow-container {
  padding: 1rem;
}

.testimonial-slider .react-slideshow-container .nav {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-size: 2.2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
  cursor: pointer;
}

.testimonial-slider .react-slideshow-container .nav:hover {
  background: rgba(255, 255, 255, 0.18);
  color: var(--white);
  transform: scale(1.12) translateY(-2px);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  border: 2px solid rgba(255, 255, 255, 0.18);
}

.testimonial-slider .react-slideshow-container .indicators {
  margin-top: 1rem;
}

.testimonial-slider .react-slideshow-container .indicators button {
  background: rgba(73, 193, 244, 0.2);
  border: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 5px;
}

.testimonial-slider .react-slideshow-container .indicators button.active {
  background: var(--light-blue);
}

/* Enhanced Contact Form */
.contact-form .form-group {
  margin-bottom: 1.5rem;
}

.contact-form select.form-control {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1.5rem;
  padding-right: 2.5rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .social-proof {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .blog-grid {
    grid-template-columns: 1fr;
  }

  .testimonial-slider .react-slideshow-container .nav {
    display: none;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

/* Custom Arrow Styles */
.testimonial-arrow {
  width: 2.2rem;
  height: 2.2rem;
  display: block;
  fill: currentColor;
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/styles.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;;;;;;EAME,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,oEAAoE;EACpE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,OAAO;EACP,oEAAoE;EACpE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oEAAoE;EACpE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,SAAS;EACT,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;EACxD,6DAA6D;AAC/D;;AAEA;EACE;IACE,iCAAiC;IACjC,gBAAgB;EAClB;EACA;IACE,wCAAwC;IACxC,gBAAgB;EAClB;AACF;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,YAAY;IACZ,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;yCACuC;EACvC,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;EAC/C,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAE,2CAA2C;AACtE;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oEAAoE;EACpE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,2CAA2C;EAC3C,4DAA4D;EAC5D,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,uCAAuC;EACvC,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yDAA6P;EAC7P,4BAA4B;EAC5B,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* Global Styles */\n:root {\n  --light-blue: #49c1f4;\n  --purple: #7761c1;\n  --dark-purple: #322a52;\n  --light-grey: #f9fdff;\n  --white: #ffffff;\n  --black: #000000;\n  --dark-bg: #121212;\n  --dark-card: #1e1e1e;\n  --transition: all 0.3s ease;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Inter\", sans-serif;\n}\n\nbody {\n  background-color: var(--dark-bg);\n  color: var(--light-grey);\n  line-height: 1.6;\n  overflow-x: hidden;\n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Typography */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 700;\n  margin-bottom: 1rem;\n  color: var(--white);\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.5rem;\n}\n\np {\n  margin-bottom: 1rem;\n}\n\na {\n  color: var(--light-blue);\n  text-decoration: none;\n  transition: var(--transition);\n}\n\na:hover {\n  color: var(--purple);\n}\n\n/* Header & Navigation */\nheader {\n  background-color: rgba(18, 18, 18, 0.9);\n  backdrop-filter: blur(10px);\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n  padding: 1rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n}\n\n.logo img {\n  height: 40px;\n  width: auto;\n  margin-right: 10px;\n}\n\n.logo h1 {\n  margin: 0;\n  margin-left: 10px;\n  font-size: 1.8rem;\n  background: linear-gradient(90deg, var(--light-blue), var(--purple));\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\nnav ul {\n  display: flex;\n  list-style: none;\n}\n\nnav ul li {\n  margin-left: 2rem;\n}\n\nnav ul li a {\n  color: var(--light-grey);\n  font-weight: 500;\n  position: relative;\n}\n\nnav ul li a:hover {\n  color: var(--light-blue);\n}\n\nnav ul li a::after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 2px;\n  bottom: -5px;\n  left: 0;\n  background: linear-gradient(90deg, var(--light-blue), var(--purple));\n  transition: var(--transition);\n}\n\nnav ul li a:hover::after {\n  width: 100%;\n}\n\n.cta-buttons {\n  display: flex;\n  align-items: center;\n}\n\n.btn {\n  padding: 0.5rem 1.5rem;\n  border-radius: 50px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n  border: none;\n  outline: none;\n}\n\n.btn-primary {\n  background: linear-gradient(90deg, var(--light-blue), var(--purple));\n  color: var(--white);\n  margin-left: 1rem;\n}\n\n.btn-secondary {\n  background: transparent;\n  color: var(--light-grey);\n  border: 1px solid var(--light-blue);\n}\n\n.btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n/* Hero Section */\n.hero {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  padding-top: 80px;\n}\n\n.map-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.2;\n  z-index: -1;\n}\n\n.hero-content {\n  max-width: 600px;\n  z-index: 1;\n}\n\n.hero-content h1 {\n  font-size: 3rem;\n  margin-bottom: 1.5rem;\n}\n\n.hero-content p {\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n}\n\n.hero-cta {\n  display: flex;\n  gap: 1rem;\n}\n\n/* Features Section */\n.features {\n  padding: 5rem 0;\n}\n\n.section-title {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.section-title h2 {\n  position: relative;\n  display: inline-block;\n  padding-bottom: 1rem;\n}\n\n.section-title h2::after {\n  content: \"\";\n  position: absolute;\n  width: 50%;\n  height: 3px;\n  bottom: 0;\n  left: 25%;\n  background: linear-gradient(90deg, var(--light-blue), var(--purple));\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.feature-card {\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  padding: 2rem;\n  transition: var(--transition);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.feature-icon {\n  width: 60px;\n  height: 60px;\n  margin-bottom: 1.5rem;\n  color: var(--light-blue);\n}\n\n.feature-card h3 {\n  margin-bottom: 1rem;\n}\n\n.feature-card p {\n  color: var(--light-grey);\n}\n\n.expand-info {\n  margin-top: 1rem;\n  color: var(--light-blue);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n}\n\n.expand-info svg {\n  margin-left: 0.5rem;\n  transition: var(--transition);\n}\n\n.expand-info:hover svg {\n  transform: translateX(5px);\n}\n\n/* Services Section */\n.services {\n  padding: 5rem 0;\n  background-color: rgba(18, 18, 18, 0.7);\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.service-card {\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  padding: 2rem;\n  transition: var(--transition);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  flex-direction: column;\n}\n\n.service-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.service-icon {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 1.5rem;\n  color: var(--light-blue);\n}\n\n.service-card h3 {\n  margin-bottom: 1rem;\n}\n\n.service-card p {\n  color: var(--light-grey);\n  flex-grow: 1;\n}\n\n/* Testimonials Section */\n.testimonials {\n  padding: 5rem 0;\n}\n\n.testimonial-slider {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.testimonial-card {\n  background: rgba(30, 30, 30, 0.7);\n  backdrop-filter: blur(6px);\n  border-radius: 10px;\n  padding: 2rem;\n  margin: 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: none;\n  position: relative;\n  overflow: hidden;\n  transition: box-shadow 0.4s, border 0.4s, transform 0.4s;\n  animation: testimonialFloat 4s ease-in-out infinite alternate;\n}\n\n@keyframes testimonialFloat {\n  0% {\n    transform: translateY(0) scale(1);\n    box-shadow: none;\n  }\n  100% {\n    transform: translateY(-8px) scale(1.012);\n    box-shadow: none;\n  }\n}\n\n.testimonial-card::before,\n.testimonial-card::after {\n  display: none !important;\n}\n\n.testimonial-card .quote-icon {\n  position: absolute;\n  top: 18px;\n  left: 24px;\n  font-size: 2.5rem;\n  color: var(--white);\n  opacity: 0.18;\n  z-index: 2;\n  pointer-events: none;\n  transition: color 0.3s;\n}\n\n.testimonial-card:hover .quote-icon {\n  color: var(--white);\n  opacity: 0.28;\n}\n\n.testimonial-content {\n  font-style: italic;\n  font-size: 1.35rem;\n  color: var(--white);\n  margin-bottom: 2rem;\n  position: relative;\n  z-index: 3;\n  animation: testimonialFadeIn 1s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.testimonial-author h4 {\n  color: var(--white);\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 0.2rem;\n}\n\n.testimonial-author p {\n  color: var(--light-grey);\n  font-size: 1rem;\n  opacity: 0.8;\n}\n\n@keyframes testimonialFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(40px) scale(0.98);\n  }\n  60% {\n    opacity: 0.7;\n    transform: translateY(-8px) scale(1.03);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.testimonial-card {\n  animation: testimonialFadeIn 1s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.testimonial-card:hover {\n  box-shadow: 0 12px 36px 0 rgba(73, 193, 244, 0.18),\n    0 2px 12px 0 rgba(119, 97, 193, 0.12);\n  border: 1.5px solid var(--light-blue);\n  transform: translateY(-6px) scale(1.01);\n}\n\n/* Partners Section - Horizontal Card Layout */\n.partners-grid {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 3rem;\n  flex-wrap: wrap;\n}\n\n.partner-card-horizontal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: none;\n  box-shadow: none;\n  border: none;\n  min-width: 220px;\n  max-width: 260px;\n  margin: 0 1rem;\n}\n\n.partner-logo img {\n  width: 240px !important;\n  height: 160px !important;\n  object-fit: contain;\n  margin-bottom: 1rem;\n  filter: grayscale(0%) brightness(2) contrast(1.2);\n  opacity: 1;\n  transition: filter 0.3s, opacity 0.3s;\n}\n\n.partner-logo img[alt=\"UCLA\"] {\n  filter: none !important;\n  opacity: 1 !important;\n}\n\n.partner-logo img:hover {\n  filter: grayscale(0%) brightness(2.2) contrast(1.3);\n  opacity: 1;\n}\n\n.partner-info {\n  text-align: center;\n}\n\n.partner-info h3 {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  color: var(--white);\n}\n\n.partner-info p {\n  font-size: 1rem;\n  color: var(--text-on-dark);\n}\n\n@media (max-width: 900px) {\n  .partners-grid {\n    flex-direction: column;\n    align-items: center;\n    gap: 2rem;\n  }\n  .partner-card-horizontal {\n    max-width: 90vw;\n    min-width: 0;\n  }\n}\n\n/* Footer */\nfooter {\n  background-color: var(--dark-bg);\n  padding: 3rem 0 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.footer-column h3 {\n  margin-bottom: 1.5rem;\n  font-size: 1.2rem;\n}\n\n.footer-column ul {\n  list-style: none;\n}\n\n.footer-column ul li {\n  margin-bottom: 0.8rem;\n}\n\n.footer-column ul li a {\n  color: var(--light-grey);\n}\n\n.footer-column ul li a:hover {\n  color: var(--light-blue);\n}\n\n.copyright {\n  text-align: center;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  color: var(--light-grey);\n  font-size: 0.9rem;\n}\n\n/* Publications List */\n.publications {\n  padding: 5rem 0;\n}\n\n.publications-container {\n  max-height: 500px;\n  overflow-y: auto;\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  padding: 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.publications-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.publications-table th,\n.publications-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.publications-table th {\n  background-color: rgba(73, 193, 244, 0.1);\n  color: var(--light-blue);\n  position: sticky;\n  top: 0;\n}\n\n.publications-table tr:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n/* Team Section */\n.team {\n  padding: 5rem 0;\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.team-card {\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  padding: 2rem;\n  text-align: center;\n  transition: var(--transition);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.team-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.team-avatar {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  margin: 0 auto 1.5rem;\n  background-color: rgba(73, 193, 244, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  color: var(--light-blue);\n}\n\n.team-card h4 {\n  font-size: 1.4rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; /* Optional: adds ... if name is too long */\n}\n\n.team-card p {\n  color: var(--light-grey);\n  margin-bottom: 1rem;\n}\n\n.team-social {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.team-social a {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.05);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--light-grey);\n  transition: var(--transition);\n}\n\n.team-social a:hover {\n  background-color: var(--light-blue);\n  color: var(--white);\n}\n\n/* Contact Section */\n.contact {\n  padding: 5rem 0;\n}\n\n.contact-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.contact-info {\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  padding: 2rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.contact-info h3 {\n  margin-bottom: 1.5rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n}\n\n.contact-icon {\n  width: 20px;\n  height: 20px;\n  margin-right: 1rem;\n  color: var(--light-blue);\n}\n\n.contact-text h4 {\n  margin-bottom: 0.3rem;\n}\n\n.contact-text p,\n.contact-text a {\n  color: var(--light-grey);\n}\n\n.contact-form {\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  padding: 2rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--light-grey);\n}\n\n.form-control {\n  width: 100%;\n  padding: 0.8rem;\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: var(--white);\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: var(--light-blue);\n}\n\ntextarea.form-control {\n  min-height: 150px;\n  resize: vertical;\n}\n\n/* Responsive Design */\n@media (max-width: 992px) {\n  .header-container {\n    flex-direction: column;\n  }\n\n  nav ul {\n    margin-top: 1rem;\n  }\n\n  nav ul li {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  .cta-buttons {\n    margin-top: 1rem;\n  }\n\n  .hero-content h1 {\n    font-size: 2.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  nav ul {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  nav ul li {\n    margin: 0.5rem 0;\n  }\n\n  .hero {\n    height: auto;\n    padding: 120px 0 60px;\n  }\n\n  .hero-content {\n    text-align: center;\n  }\n\n  .hero-cta {\n    justify-content: center;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.8s ease forwards;\n}\n\n/* Particle Background */\n#tsparticles {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--dark-bg);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--dark-purple);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--purple);\n}\n\n/* Center the partners-cta section */\n.partners-cta {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.partners-cta p {\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n  color: var(--white);\n}\n\n/* Video Background */\n.video-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: -1;\n}\n\n.video-background video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.3;\n}\n\n/* Social Proof Badges */\n.social-proof {\n  display: flex;\n  gap: 2rem;\n  margin-top: 2rem;\n  justify-content: center;\n}\n\n.badge {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 0.5rem 1rem;\n  border-radius: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.badge img {\n  height: 24px;\n  width: auto;\n}\n\n.badge span {\n  color: var(--white);\n  font-size: 0.9rem;\n}\n\n/* Stats Section */\n.stats {\n  padding: 4rem 0;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n  text-align: center;\n}\n\n.stat-card {\n  padding: 2rem;\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: var(--transition);\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  background-color: rgba(30, 30, 30, 0.8);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.stat-icon {\n  width: 50px;\n  height: 50px;\n  margin: 0 auto 1rem;\n  color: var(--light-blue);\n  background: rgba(73, 193, 244, 0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stat-card h3 {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n  background: linear-gradient(90deg, var(--light-blue), var(--purple));\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.stat-card p {\n  color: var(--light-grey);\n  font-size: 1.1rem;\n}\n\n/* Blog Section */\n.blog {\n  padding: 5rem 0;\n  background-color: var(--dark-bg);\n}\n\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.blog-card {\n  background-color: var(--dark-card);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: var(--transition);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.blog-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.blog-image {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n}\n\n.blog-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: var(--transition);\n}\n\n.blog-card:hover .blog-image img {\n  transform: scale(1.1);\n}\n\n.blog-content {\n  padding: 1.5rem;\n}\n\n.blog-category {\n  display: inline-block;\n  padding: 0.3rem 0.8rem;\n  background: rgba(73, 193, 244, 0.1);\n  color: var(--light-blue);\n  border-radius: 50px;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.blog-content h3 {\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n.blog-content p {\n  color: var(--light-grey);\n  margin-bottom: 1.5rem;\n}\n\n.read-more {\n  color: var(--light-blue);\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.read-more:hover {\n  color: var(--purple);\n}\n\n/* Enhanced Testimonials */\n.testimonial-slider {\n  max-width: 800px;\n  margin: 0 auto;\n  position: relative;\n}\n\n.testimonial-slider .react-slideshow-container {\n  padding: 1rem;\n}\n\n.testimonial-slider .react-slideshow-container .nav {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  width: 54px;\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  font-size: 2.2rem;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n  border: 2px solid rgba(255, 255, 255, 0.08);\n  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;\n  cursor: pointer;\n}\n\n.testimonial-slider .react-slideshow-container .nav:hover {\n  background: rgba(255, 255, 255, 0.18);\n  color: var(--white);\n  transform: scale(1.12) translateY(-2px);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);\n  border: 2px solid rgba(255, 255, 255, 0.18);\n}\n\n.testimonial-slider .react-slideshow-container .indicators {\n  margin-top: 1rem;\n}\n\n.testimonial-slider .react-slideshow-container .indicators button {\n  background: rgba(73, 193, 244, 0.2);\n  border: none;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin: 0 5px;\n}\n\n.testimonial-slider .react-slideshow-container .indicators button.active {\n  background: var(--light-blue);\n}\n\n/* Enhanced Contact Form */\n.contact-form .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.contact-form select.form-control {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2349c1f4'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 1.5rem;\n  padding-right: 2.5rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .social-proof {\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .blog-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .testimonial-slider .react-slideshow-container .nav {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Custom Arrow Styles */\n.testimonial-arrow {\n  width: 2.2rem;\n  height: 2.2rem;\n  display: block;\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
